import url from 'url';
import { NAVIGATION_STATE_PARAM_NAME, OFFSET_PARAM_NAME, PRODUCTS_PER_PAGE_PARAM_NAME, } from '@pes-ui/utils/lib/constants';
import { isV3 } from '@pes-ui/utils';
import { getData } from '../../globals/utils';
import { parseRecords } from '../../globals/utils/parsers';
import { clearNormalizedFilterData, normalizeFilters, changeCategoriesFields, } from '../../globals/utils/normalizeFiltersData';
import { getNavigationState, getProductsUrl, getQueryParam, setQueryParam, } from '../../globals/utils/helpers';
export function getPaginationParams(defaults) {
  const offset = Number(getQueryParam(OFFSET_PARAM_NAME, defaults.offset.toString()));
  const productsPerPage = Number(getQueryParam(PRODUCTS_PER_PAGE_PARAM_NAME, defaults.productsPerPage.toString()));
  return { offset, productsPerPage };
}
export function setPaginationOffset(offset, pushToHistory = false) {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}
export function setPaginationParams(offset, Nrpp, pushToHistory = false) {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
  setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, Nrpp.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}
export function setProductsPerPage(Nrpp, pushToHistory = false) {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, Nrpp.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}
function getCategories(filters) {
  var _a, _b;
  const categories = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters[0]) === null || _a === void 0 ? void 0 : _a.filterRefinements) !== null && _b !== void 0 ? _b : [];
  return categories.map(({ checked, navigationState, label }) => ({
    checked,
    navigationState,
    label,
  }));
}
const getQueryObject = ({ filter, navState, pageParam, }) => {
  if (getNavigationState(navState) === '?') {
    return {};
  }
  const queryObj = {
    filter,
    n: getNavigationState(navState),
    pageParam,
  };
  const queryParams = Object.keys(queryObj)
    .filter((key) => Boolean(queryObj[key]))
    .reduce((acc, k) => (Object.assign(Object.assign({}, acc), { [k]: queryObj[k] })), {});
  return queryParams;
};
export async function fetchFilters(pathname, params) {
  const query = getQueryObject(params);
  const filtersUrl = url.format({ pathname, query });
  const response = await getData(false, filtersUrl);
  const { filters, pills, selectedFiltersQty } = response || {};
  let filtersNormalized;
  let filtrationSmartData;
  if (filters === null || filters === void 0 ? void 0 : filters.length) {
    filters.forEach((facet) => {
      facet.nativeFilterCategory = facet.filterCategory;
      changeCategoriesFields(facet.filterCategory, facet.subcharacteristics);
    });
    filtersNormalized = normalizeFilters(filters);
    filtrationSmartData = clearNormalizedFilterData(filtersNormalized);
  }
  const filtersCategories = getCategories(filters);
  return {
    filtersNormalized,
    filtrationSmartData,
    pills,
    filtersCategories,
    selectedSectionsCount: selectedFiltersQty,
  };
}
export async function fetchProducts(productsUrl, navState, offset, productsPerPage, filter) {
  const url = getProductsUrl(productsUrl, navState, offset, productsPerPage, filter);
  const response = await getData(false, url);
  const parsedProducts = parseRecords({ contents: [response] });
  return parsedProducts;
}
export async function fetchRanges(pathname, navState, filter, params) {
  const paramsObject = {
    pathname,
    query: Object.assign({}, (filter && { filter })),
  };
  if (isV3()) {
    paramsObject.query.brand = params.brand;
    paramsObject.query['country-code'] = params.countryCode;
    paramsObject.query['language-code'] = params.languageCode;
  }
  if (navState !== '?') {
    paramsObject.query.n = getNavigationState(navState);
  }
  const rangesUrl = url.format(paramsObject);
  return getData(false, rangesUrl);
}
export function mergePaginationConfig(productsInfo, existingPaginationConfig, { isDesktop }) {
  const { totalNumRecs, firstRecNum, lastRecNum, records } = productsInfo;
  const { firstLoadedRecNum, lastLoadedRecNum } = existingPaginationConfig;
  return {
    firstRecNum,
    lastRecNum,
    totalNumRecs,
    hasProducts: (records === null || records === void 0 ? void 0 : records.length) > 0,
    firstLoadedRecNum: isDesktop || firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, firstLoadedRecNum),
    lastLoadedRecNum: isDesktop || lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, lastLoadedRecNum),
  };
}
export function getNavigationStateParam(defaultNavigationState = '') {
  return getNavigationState(getQueryParam(NAVIGATION_STATE_PARAM_NAME, defaultNavigationState));
}
export function handleNavigationState(navState) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(OFFSET_PARAM_NAME);
  searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
  setQueryParam(searchParams, NAVIGATION_STATE_PARAM_NAME, getNavigationState(navState));
  window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
}
export const getNavState = (filter, filterId) => {
  var _a;
  const navStateFromFilter = (_a = filter[filterId]) === null || _a === void 0 ? void 0 : _a.navigationState;
  return new URLSearchParams(navStateFromFilter).get('n');
};
